import { inject, Injectable } from '@angular/core';
import { CartHttpService } from '../services/cart.http.service';
import { Observable } from 'rxjs';
import { ICart, ICartCreateWithEquipmentResponse } from '../../../../models/cart.models';
import { Store } from '@ngrx/store';
import { State } from '../../../../reducers';
import { ShopCartActions } from '../../../../actions';
import { IAddress } from '../../../../models/common.models';

@Injectable({providedIn: 'root'})
export class CartFacade {
  private readonly cartHttpService: CartHttpService = inject(CartHttpService);
  private readonly store: Store<State> = inject(Store<State>);

  // *** Executing HTTP Requests ***
  createNewCartWithEquipment(equipmentId: string, soldToAddress?: IAddress): Observable<ICartCreateWithEquipmentResponse> {
    return this.cartHttpService.createNewCartWithEquipment(equipmentId, soldToAddress);
  }

  // *** Dispatching Actions ***
  setAllUserCarts(carts: ICartCreateWithEquipmentResponse): void {
    // TODO: After fully implementing Cart entity, use new actions, that will be created inside this module and work on cart state instead of shopCart state.
    this.store.dispatch(ShopCartActions.loadCartsSuccess({ carts }));
  }

  /**
   * For cart operations, we use shopCart -> cart in state. After loading all carts for user, it is also necessary to set current cart in "cart" property.
   * @param {ICart} cart
   */
  setCurrentCart(cart: ICart): void {
    // TODO: After fully implementing Cart entity, use new actions, that will be created inside this module and work on cart state instead of shopCart state.
    this.store.dispatch(ShopCartActions.loadCartSuccess({ cart }));
    // TODO: Technical debt:
    // After fully implementing Cart entity, this call of action "switchDefaultCart" should be redundant. Currently, it is necessary to call this action,
    // because "Load current cart and cart items" action is triggered on initialization of shopCart state and overwrites current cart in "cart" property
    // with default cart, that is not existing during shopCart state initialization.
    this.store.dispatch(ShopCartActions.switchDefaultCart({ cartId: cart.id }));
  }
}
